import { FileType } from "@/domain/upload/value-objects/FileType";
import { ConfirmTextFileUploadRequestDTO } from "../dtos/ConfirmTextFileUploadRequestDTO";
import { ConfirmTextFileUploadResponseDTO } from "../dtos/ConfirmTextFileUploadResponseDTO";
import { UploadPlaceholderRecordDTO } from "../dtos/UploadTaskDTO";
import { FileUploadRepository } from "../ports/FileUploadRepository";

const DEFAULT_PLACEHOLDER_PROJECT = "";
const DEFAULT_PLACEHOLDER_STATUS = "Uploaded";

export class ConfirmTextFileUploadUseCase {
  constructor(private readonly repository: FileUploadRepository) {}

  async execute(
    request: ConfirmTextFileUploadRequestDTO
  ): Promise<ConfirmTextFileUploadResponseDTO> {
    const {
      taskId,
      projectId,
      recordName,
      content,
      extension,
      transcriptFormat,
    } = request;

    const uploadResult = await this.repository.uploadTextFile(
      {
        recordName,
        content,
        extension,
        transcriptFormat,
      },
      projectId
    );

    const placeholderRecord = this.createPlaceholder({
      id: uploadResult.id,
      name: recordName,
      extension,
    });

    return {
      taskId,
      placeholderRecord,
    };
  }

  private createPlaceholder({
    id,
    name,
    extension,
  }: {
    id: string;
    name: string;
    extension: string;
  }): UploadPlaceholderRecordDTO {
    const timestamp = new Date().toISOString();
    return {
      id,
      name,
      project: DEFAULT_PLACEHOLDER_PROJECT,
      status: DEFAULT_PLACEHOLDER_STATUS,
      fileName: `${name}.${extension}`,
      fileExtension: extension,
      sizeMb: 0,
      durationSec: null,
      createdAt: timestamp,
      updatedAt: timestamp,
      type: "text" as FileType,
    };
  }
}
